<div>
    <div class="back">
        <a (click)="back()">
            <h6 class="desktop700"><span class="icon-back "></span> {{this.type != 'new' ? this.Model.ModelYear : null}} {{this.Model.WebFriendlyName ? this.Model.WebFriendlyName : this.Model.ModelDescription || this.Model.Caption}}</h6>
            <h5 class="mobile700"><span class="icon-back "></span> {{this.type != 'new' ? this.Model.ModelYear : null}} {{this.Model.WebFriendlyName ? this.Model.WebFriendlyName : this.Model.ModelDescription || this.Model.Caption}}</h5>
        </a>
    </div>
    <div *ngIf="this.type == 'new'" class="row details">
        <div class="mobile700 bord pricol">
            <h4 *ngIf="this.Model.NewVehiclePrice">{{this.currency}}{{this.Model.NewVehiclePrice | number:'1.0-0'}} <span *ngIf="VehicleMakeTypeExcludeVAT.length > 0 && VatExclusive(this.Model.VehicleType, this.Model.VehicleMakeID_FK)" style="font-size: 16px;">Ex VAT</span></h4>
            <h4 *ngIf="!this.Model.NewVehiclePrice">POA</h4>
            <h6 *ngIf="Ford" class="ford-credit">* Subject to Finance from Ford Credit</h6>
        </div>
        <div class="carpic col-12 pad">
            <div *ngIf="this.Images !== null && this.Images[0]">
                <app-slider [activeIndex]="imgaeindex" [autoScroll]="false" [carouselStyling]="'custom-control'" [images]="this.Images"
                    *ngIf="this.Images!==null"></app-slider>                
                <app-imglist [(index)]="imgaeindex" [Images]="this.Images" *ngIf="this.Images.length>0"></app-imglist>
            </div>
            <div *ngIf="this.Images == null || !this.Images[0]">
                <img class="fallbackimg" loading="lazy" *ngIf="this.Images == null" src="{{currentSite.vehicleImages?.Value}}" alt="">
            </div>
        </div>
        <div class="carspecs col-12 pad">

            <h5 class="desktop700">{{this.Model.ModelDescription}}</h5>
            <div class="desktop700 row pricing bord">
                <h4 class="" *ngIf="this.Model.NewVehiclePrice">{{this.currency}}{{this.Model.NewVehiclePrice | number:'1.0-0'}} <span *ngIf="VehicleMakeTypeExcludeVAT.length > 0 && VatExclusive(this.Model.VehicleType, this.Model.VehicleMakeID_FK)" style="font-size: 16px;">Ex VAT</span></h4>
                <h4 *ngIf="!this.Model.NewVehiclePrice">POA</h4>

                <h6 *ngIf="!hideFinance && this.Model.NewVehiclePrice" class="">From {{this.currency}}{{monthlyPayment(this.Model.NewVehiclePrice||this.Model.Price) | number:'1.0-0' }} pm</h6>
                <h6 *ngIf="Ford" class="ford-credit">* Subject to Finance from Ford Credit</h6>
            </div>
            <div class="bord" *ngIf="this.extraInfo && (this.Model.ServicePlanPrice != null && this.Model.ServicePlanPrice != 0) && (this.Model.MaintenancePlanPrice != null && this.Model.MaintenancePlanPrice != 0)">
                <h6>Price Information</h6>
                <div class="specs">
                    <tr>
                        <td>Retail Price:</td>
                        <td class="align-right">{{this.currency}}{{this.Model.NewVehiclePrice | number:'1.0-0'}} <span *ngIf="VehicleMakeTypeExcludeVAT.length > 0 && VatExclusive(this.Model.VehicleType, this.Model.VehicleMakeID_FK)" style="font-size: 16px;">Ex VAT</span></td>
                    </tr>
                    <tr *ngIf="(this.Model.ServicePlanPrice != null && this.Model.ServicePlanPrice != 0)">
                        <td>Service Plan Price: (Optional)</td>
                        <td class="align-right">{{this.currency}}{{this.Model.ServicePlanPrice | number:'1.0-0'}}</td>
                    </tr>
                    <tr *ngIf="(this.Model.MaintenancePlanPrice != null && this.Model.MaintenancePlanPrice != 0)">
                        <td>Maintenance Plan Price: (Optional)</td>
                        <td class="align-right">{{this.currency}}{{this.Model.MaintenancePlanPrice | number:'1.0-0'}}</td>
                    </tr>
                </div>
            </div>
            <h6 class="bord">Vehicle Information</h6>

            <div class="specs" *ngIf="this.Specs.length>0" [ngClass]="specsOpen?'open':''">
                <!--<tr *ngFor="let spec of this.Specs">
            <td>{{spec.Name}}</td>
            <td>{{spec.Value}}</td>
        </tr>-->

                <tr>
                    <td>Acceleration (0-100km/h):</td>
                    <td class="align-right">{{spec("0-100 (sec)")}}</td>
                </tr>
                <tr>
                    <td>Body Shape:</td>
                    <td class="align-right">{{spec("Body Shape")}}</td>
                </tr>
                <tr>
                    <td>ECE Emissions:</td>
                    <td class="align-right">{{spec("Emission Control")}}</td>
                </tr>
                <tr>
                    <td>Fuel Consumption @ 100 (CT):</td>
                    <td class="align-right">{{spec("City KM/L")}}</td>
                </tr>
                <tr>
                    <td>Fuel Type:</td>
                    <td class="align-right">{{spec("Fuel Type")}}</td>
                </tr>
                <tr>
                    <td>Gearbox:</td>
                    <td class="align-right">{{spec("Transmission")}}</td>
                </tr>
                <tr>
                    <td>Service Intervals - Kms:</td>
                    <td class="align-right">{{spec("Service Intervals - Kms") | number:'1.0-0'}}</td>
                </tr>
                <tr>
                    <td>Warranty - Kms:</td>
                    <td class="align-right">{{num(spec("Warranty - Kms"))}}</td>
                </tr>
                <tr>
                    <td>Warranty - Years:</td>
                    <td class="align-right">{{spec("Warranty - Years")}}</td>
                </tr>
                <div *ngIf="this.extraInfo">
                    <tr *ngIf="num(specNam('Service Plan - Kms')) != '-'">
                        <td>Service Plan - Kms:</td>
                        <td class="align-right">{{num(specNam("Service Plan - Kms"))}}</td>
                    </tr>
                    <tr *ngIf="specNam('Service Plan - Years') != '-'">
                        <td>Service Plan - Years:</td>
                        <td class="align-right">{{specNam("Service Plan - Years")}}</td>
                    </tr>
                    <tr *ngIf="num(specNam('Maintenance Plan - Kms')) != '-'">
                        <td>Maintenance Plan - Kms:</td>
                        <td class="align-right">{{num(specNam("Maintenance Plan - Kms"))}}</td>
                    </tr>
                    <tr *ngIf="specNam('Maintenance Plan - Years') != '-'">
                        <td>Maintenance Plan - Years:</td>
                        <td class="align-right">{{specNam("Maintenance Plan - Years")}}</td>
                    </tr>
                </div>
            </div>
            <!--<button class="btn-tertiary col-12" (click)="specsOpen=!specsOpen">More</button>-->
            <button class="btn-primary col-12" (click)="enquire()">Enquire</button>
            <div class="row">
                <a *ngIf="!hideFinance  && (this.Model.NewVehiclePrice)" (click)="finance()" class="col-4 icon"><span class="icon-calccircle"></span>Finance
                    Calculator</a>
                <a *ngIf="this.Model.Brochure" href="{{this.Model.Brochure}}" target="_blank" class="col-4 icon"><span
                        class="icon-brocurecircle"></span>Brochure</a>
                <a *ngIf="this.Model.Accessories && this.Model.IsNew" href="{{this.Model.Accessories}}" target="_blank" class="col-4 icon"><span
                    class="icon-accessories-circle"></span>Accessories</a>
                <a (click)="compare()" class="col-4 icon"><span class="icon-scalecircle"></span>Vehicle
                    Comparison</a>
                <a href="/pricecompare/{{this.Model.VehicleSeriesID_FK}}" class="col-4 icon"><span
                        class="icon-magcircle"></span>Compare Prices</a>

            </div>
            <button class="btn-tertiary col-12" (click)="back()">
                <span class="icon-back"></span> Return to Previous Page</button>
        </div>
        <div class="modelcolours" *ngIf="this.Model.VehicleModelID_PK">
            <app-modelcolour [hideColourName]="hideColourName" [modelid]="this.Model.VehicleModelID_PK" [hideVehicleImage]="HideVehicleImage"></app-modelcolour>
        </div>
        <h5 class="stockhead" *ngIf="Stock.length > 0">There are a number of new listings on the floors of Bidvest McCarthy dealerships</h5>
            
        <div class="stock">
            <div *ngFor="let v of Stock, let ind = index" class="col-10 offset-1 offset-md-0 col-md-2" [ngClass]="ind==0?Stock.length==1?'offset-md-5': Stock.length==2?'offset-md-4': Stock.length==3?'offset-md-3': 'offset-md-2':''">
        <div *ngIf="ind <= 3" class="card ">
            <div class="allstocklistings" *ngIf="ind == 3 && Stock.length>4">
                <a href="/buy?type=newstock&model={{this.Model.VehicleModelID_PK}}">
                    <h4> View all <br> New Listings <br> available <br> <span class="icon-back"></span> </h4>
                </a>
            </div>
            <div *ngIf="ind < 3 || Stock.length == 4">
            <a class="image card-img-top"

                href="buy/stock/{{v.VehicleStockID_PK||v.VehicleID}}/{{urlsan(v.WebFriendlyName||v.ModelDescription)}}">

                <img *ngIf="v.InstavidSpinID" class="instavidimg" src="assets/360img.png" alt=""/>
                <img loading="lazy" *ngIf="v.Images == null || !v.Images[0]" src="{{currentSite.vehicleImages?.Value}}" alt="">

                <app-slider [id]="'stock'+(v.VehicleStockID_PK||v.VehicleID)" [activeIndex]="0"
                    [autoScroll]="false" [images]="v.Images" [carouselStyling]="'custom-control'" *ngIf="v.Images!==null"></app-slider>
            </a>
            <div class="card-body">
                <div class="bodyblock">
                    <div class="row name">
                        <h6>{{v.ModelYear}} {{v.WebFriendlyName||v.ModelDescription}}</h6><button
                            [ngClass]="isfav(v,'stock')?'selected':''"
                            (click)="fav(v.VehicleStockID_PK||v.VehicleID,'stock')"><span
                                class="icon-favourite"></span></button>
                    </div>
                    <div class="row pricerow">
                        <h5 class="col-6">{{this.currency}}{{v.RetailPriceIncl||v.Price | number:'1.0-0'}}</h5>
                        <a class="col-6" (click)="stockfinance(v.RetailPriceIncl||v.Price)">
                            <p>From {{this.currency}}{{monthlyPayment(v.RetailPriceIncl||v.Price)| number:'1.0-0'}} pm</p>
                        </a>
                    </div>
                    <p class="details">{{v.OdoMeterReading| number:'1.0-0'}}kms | {{v.VehicleTransmission}}
                        | {{v.VehicleFuelType||v.FuelType}} | {{v.VehicleStockType||v.Type}} </p>
                    <p class="dealerdetails">{{v.DealershipName}} </p>
                </div>
            </div>
            <div class="card-footer">
                <div class="row">
                    <div class="col-xs-10 col-xs-offset-1">
                        <button class="col-4 btn-tertiary marginSides"
                            (click)="href('buy/'+(((v.VehicleStockType||v.Type) == 'Pre-Owned' || (v.VehicleStockType||v.Type) == 'Demo' || (v.VehicleStockType||v.Type) == 'New')?'stock':(v.VehicleStockType.toLowerCase( )||v.Type.toLowerCase( )))+'/'+(v.VehicleStockID_PK||v.VehicleID)+'/'+urlsan((v.WebFriendlyName||v.ModelDescription)))"><span
                                class="icon-info"></span> Info</button>
                        <button (click)="stockenquire(v)" class="col-4 btn-primary marginSides">Enquire</button>
                        <a class="call" href="tel:{{v.DealershipPhoneNumber}}"><span
                                class="icon-phone"></span></a>
                    </div>
                </div>

            </div>
            </div>
        </div>
    </div>
    </div>
        <div class="row dealers col-10 offset-1">
            <h4>Available at these {{currentSite?.container?.Name}} Dealerships</h4>

            <div class="col-sm-2_4 col-6 item" *ngFor="let d of Dealerships">
                <a href="dealership/{{d.DealershipID_PK}}">
                    <div class="dealerimg">
                        <img loading="lazy" class="" src="{{d.Image}}" alt="">
                    </div>
                    <h6>{{d.Name}}</h6>
                </a>
            </div>
        </div>
    </div>
    <div *ngIf="this.type == 'stock'" class="row details">
        <div class="mobile700 bord pricol">
            <h4>{{this.currency}}{{this.Model.RetailPriceIncl | number:'1.0-0'}}</h4>
            <h6 *ngIf="Model.FinanceStockOptionID_FK" class="ford-credit">* {{this.Model.FinanceStockOption}}</h6>
        </div>
        <div class="carpic col-12 pad">
            <img *ngIf="(this.Model.VehicleStockType == 'Demo' || this.Model.VehicleStockType == 'Pre-Owned') && this.Model.CampaignVehicle" class="CampaignImg" src="assets/CampaignImage.png" alt=""/>
            <app-slider [activeIndex]="imgaeindex" [autoScroll]="false" [carouselStyling]="'custom-control'" [images]="this.Images"
                *ngIf="this.Images !== null && this.Images[0] && galltype == 0"></app-slider>
            <app-imglist [(index)]="imgaeindex" [Images]="this.Images"
                *ngIf="this.Images.length>0 && galltype == 0"></app-imglist>
            <div *ngIf="galltype == 1" #spin></div>
            <video *ngIf="galltype == 2" controls="" autoplay="" name="media">
                <source [src]="this.Model.InstavidVidURL|safe" type="video/mp4">
            </video>


            <div class="row gallerybuttons">
                <button (click)="this.galltype = 0; this.Loaded360 = false"
                    [ngClass]="this.Model.InstavidSpinID && this.Model.InstavidVidURL?'gall3':'gall2'"
                    *ngIf="this.Model.InstavidSpinID || this.Model.InstavidVidURL" class="btn-primary">Gallery</button>
                <button (click)="this.galltype = 1; loadScripts();"
                    [ngClass]="this.Model.InstavidSpinID && this.Model.InstavidVidURL?'gall3':'gall2'"
                    *ngIf="this.Model.InstavidSpinID" class="btn-primary">360</button>
                <button (click)="this.galltype = 2; this.Loaded360 = false"
                    [ngClass]="this.Model.InstavidSpinID && this.Model.InstavidVidURL?'gall3':'gall2'"
                    *ngIf="this.Model.InstavidVidURL" class="btn-primary">Video</button>
            </div>
            <img class="fallbackimg" loading="lazy" *ngIf="this.Images == null || !this.Images[0]" src="{{currentSite.vehicleImages?.Value}}" alt="">
        </div>
        <div class="carspecs col-12 pad">
            <h6>{{this.Model.DealershipName}}</h6>
            <app-reviews *ngIf="Dealer" [reviewnumber]="Dealer.GoogleRatingReviews"
                [reviewscore]="Dealer.GoogleRatingScore"></app-reviews>
            <div class="text-center callbutt"><a class="call col-1"
                    href="tel:{{this.Model.DealershipPhoneNumber}}"><span class="icon-phone"></span></a></div>
            <h5 class="bbord desktop700">{{this.Model.ModelYear}} {{this.Model.WebFriendlyName}}</h5>
            <div class="row desktop700 pricing">
                <h4 class="">{{this.currency}}{{this.Model.RetailPriceIncl | number:'1.0-0'}}</h4>
                <h6 *ngIf="!hideFinance" class="">From {{this.currency}}{{monthlyPayment(this.Model.RetailPriceIncl) | number:'1.0-0' }} pm</h6>
                <h6 *ngIf="Model.FinanceStockOptionID_FK" class="ford-credit">* {{this.Model.FinanceStockOption}}</h6>
            </div>

            <div id="accordionInfo">
                <div>

                    <button class="accordion-button bord" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseInformation" aria-expanded="true" aria-controls="collapseOne">
                        <h6 class="spacer"></h6>
                        <h6 class="accordion-header " id="headingInformation">
                            Vehicle Information
                        </h6>
                        <h6 class="accordion-header plus closed">+</h6>
                        <h6 class="accordion-header plus open">-</h6>
                    </button>
                </div>

                <div id="collapseInformation" class="accordion-collapse collapse show"
                    aria-labelledby="headingInformation" data-bs-parent="#accordionInfo">
                    <div class="accordion-body">

                        <div class="vehicledetails">
                            <tr>
                                <td>Kilometres</td>
                                <td>{{this.Model.OdoMeterReading| number:'1.0-0'}} kms</td>
                            </tr>
                            <tr>
                                <td>Body Shape</td>
                                <td>{{this.Model.VehicleBodyType}}</td>
                            </tr>
                            <tr>
                                <td>Fuel Type</td>
                                <td>{{this.Model.VehicleFuelType}}</td>
                            </tr>
                            <tr>
                                <td>Transmission</td>
                                <td>{{this.Model.VehicleTransmission}}</td>
                            </tr>
                            <tr>
                                <td>Full Service History</td>
                                <td>{{this.Model.FullServiceHistory?'Yes':'No'}}</td>
                            </tr>
                        </div>
                    </div>
                </div>
                <div *ngIf="Accessories.length>0" class="accordion-item vehiclefeatures">


                    <div>

                        <button class="accordion-button collapsed bord" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseFeatures" aria-expan ded="false" aria-controls="collapseOne">
                            <h6 class="spacer"></h6>
                           <h6 class="accordion-header " id="headingFeatures">
                                Vehicle Features
                            </h6>
                            <h6 class="accordion-header plus closed">+</h6>
                            <h6 class="accordion-header plus open">-</h6>
                        </button>
                    </div>

                    <div id="collapseFeatures" class="accordion-collapse collapse" aria-labelledby="headingFeatures"
                        data-bs-parent="#accordionInfo">
                        <div class="accordion-body">
                            <ul>
                               
                                    <li *ngFor="let col of Accessories">{{col}}</li>
                                
                            </ul>
                        </div>
                    </div>
                </div>
                <button *ngIf="currentSite?.layoutFeatures.includes('isAutomark')" class="accordion-button collapsed bord" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseSpecialType" aria-expanded="false" aria-controls="collapseOne">
                    <h6 class="spacer"></h6>
                    <div class="imgs">
                    <img *ngIf="Model.Policy == 'TWA1'" src="assets/toyotacert.png" alt="">
                    <img *ngIf="Model.Policy !== 'TWA1'" src="assets/autocert.png" alt="">
                </div>
                    <h6 class="accordion-header plus closed">+</h6>
                    <h6 class="accordion-header plus open">-</h6>
                </button>
                <div *ngIf="currentSite?.layoutFeatures.includes('isAutomark')" id="collapseSpecialType" class="accordion-collapse collapse" aria-labelledby="headingSpecialType"
                    data-bs-parent="#accordionInfo">
                    <div class="accordion-body">
                        <div *ngIf="Model.Policy == 'TWA1'" class="toyota certified">


                            <div><span class="icon-toyotalogo"></span>
                                <p>All Toyota Models up to 4 years</p>
                            </div>
                            <div><span class="icon-steeringwheel"></span>
                                <p>Less than 100 000 Kms</p>
                            </div>
                            <div><span class="icon-shield"></span>
                                <p>Complementary 1-year/50 000 kms Warranty</p>
                            </div>

                        </div>
                        <div *ngIf="Model.Policy !== 'TWA1'" class="certified">

                            <div><span class="icon-toyotalogo"></span>
                                <p>All Toyota Models older than 4 years and Non-Toyota Models</p>
                            </div>
                            <div><span class="icon-steeringwheel"></span>
                                <p>No Restrictions on Kms</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <tr>
            <td>Body Type</td>
            <td>{{this.Model.VehicleBodyType}}</td>
        </tr>
        <tr>
            <td>Fuel Type</td>
            <td>{{this.Model.VehicleFuelType}}</td>
        </tr>
        <tr>
            <td>Transmission</td>
            <td>{{this.Model.VehicleTransmission}}</td>
        </tr>-->
            <div class="row"><button class="btn-primary col-12" (click)="enquire()">Enquire</button></div>
            <div class="row">
                <a *ngIf="!hideFinance" (click)="finance()" class="col-4 icon"><span class="icon-calccircle"></span>Finance
                    Calculator</a>
                <a *ngIf="this.Model.Accessories && this.Model.IsNew" href="{{this.Model.Accessories}}" target="_blank" class="col-4 icon"><span
                    class="icon-accessories-circle"></span>Accessories</a>
                <a (click)="compare()" class="col-4 icon"><span class="icon-scalecircle"></span>Vehicle
                    Comparison</a>
            </div>

            <button class="btn-tertiary col-12" (click)="back()">
                <span class="icon-back"></span> Return to Previous Page</button>
        </div>
    </div>
    <div *ngIf="this.type == 'special'" [ngStyle]="!imgloaded?{'display':'none'}:{}" class="row details special">

        <div class="carpic col-12 pad">
            <img loading="lazy" *ngIf="this.Model.Image" src="{{this.Model.Image}}">
            <img class="fallbackimg" loading="lazy" *ngIf="!this.Model.Image" src="{{currentSite.vehicleImages?.Value}}" alt="">
        </div>
        <div class="carspecs col-12 pad">
            <div class="align-call">
            <div class="col-12">
            <h6 *ngIf="this.Dealer">{{this.Dealer.Name}}</h6>
            <app-reviews *ngIf="Dealer" [reviewnumber]="Dealer.GoogleRatingReviews"
                [reviewscore]="Dealer.GoogleRatingScore"></app-reviews></div>
            <div *ngIf="this.Dealer" class="text-center callbutt"><a class="call col-1"
                    href="tel:{{this.Model.DealershipPhoneNumber}}"><span class="icon-phone"></span></a></div>
            </div>
            <h4 class="desktop700">{{this.Model.Caption}}</h4>
            <p class="bbord desctcs">{{this.Model.Description}} 
                <br/> Offer valid until {{this.Model.DateEnd}}
                <br> Terms and Conditions apply</p>
            <div class="row">
                <h4 class="col-12 specialprice">{{this.Model.PriceText}}</h4>
                
            </div>

            <app-enquire [Data]="{Name:this.modelname, Type:'specials', ID:this.modelId, Dealer:null}"></app-enquire>
            

           <!-- <div class="row"><button class="specialbutton btn-primary col-12" (click)="enquire()">Enquire</button></div>

           -->

           <!--<button class="btn-tertiary col-12" (click)="back()">
                <span class="icon-back"></span> Return to Previous Page</button>-->

        </div>
    </div>
    <div *ngIf="this.type == 'promo'" [ngStyle]="!imgloaded?{'display':'none'}:{}" class="row details promo">

        <div class="promoimg col-12">
            <img loading="lazy" class="d-sm-none" *ngIf="this.Model.promo.ImageFilenameXS" src="{{this.Model.promo.ImageFilenameXS}}">
            <img loading="lazy" class="d-none d-sm-block d-md-none" *ngIf="this.Model.promo.ImageFilenameSM" src="{{this.Model.promo.ImageFilenameSM}}">
            <img loading="lazy" class="d-none d-md-block d-lg-none" *ngIf="this.Model.promo.ImageFilenameMD" src="{{this.Model.promo.ImageFilenameMD}}">
            <img loading="lazy" class="d-none d-lg-block" *ngIf="this.Model.promo.ImageFilenameLG" src="{{this.Model.promo.ImageFilenameLG}}">

            <img class="fallbackimg" loading="lazy" *ngIf="!this.Model.promo.ImageFilenameLG" src="{{currentSite.vehicleImages?.Value}}" alt="">
        </div>
        <div class="promopecs col-12 pad">
            <h6 *ngIf="this.Dealer">{{this.Dealer.Name}}</h6>
            <app-reviews *ngIf="Dealer" [reviewnumber]="Dealer.GoogleRatingReviews"
                [reviewscore]="Dealer.GoogleRatingScore"></app-reviews>
            <div *ngIf="this.Dealer" class="text-center callbutt"><a class="call col-1"
                    href="tel:{{this.Model.DealershipPhoneNumber}}"><span class="icon-phone"></span></a></div>
            <h4 class="">{{this.Model.promo.AdditionalInfo}}</h4>
            <p class="bbord desctcs">Ref: {{this.Model.promo.Reference}}</p>
            <div class="row">
                <h4 class="col-12 specialprice">{{this.Model.PriceText}}</h4>
            </div>



            <div class="row"><button class="specialbutton btn-primary col-12" (click)="enquire()">Enquire</button></div>



            <button class="btn-tertiary col-12" (click)="back()">
                <span class="icon-back"></span> Return to Previous Page</button>

        </div>
    </div>
</div>